// Shared table-cell renderer for the "At a glance" sub-tabs — wraps ./utils.js's
// formatGlanceValue/getGlanceValueColor (ported from LC2's TableBodyCell.js) so every Glance
// column (ConcessionGlance, DaysOnMarketGlance, DelinquencyGlance, VacancyGlance,
// ExposureGlance) renders and colors its cells the same way.
import React from 'react';
import PropTypes from 'prop-types';
import {Typography, useTheme} from '@mui/material';

import {formatGlanceValue, getGlanceValueColor} from './utils';

const GlanceCell = ({value, format, color, colorValue}) => {
    const theme = useTheme();
    const display = formatGlanceValue(value, format);
    const textColor = getGlanceValueColor(value, color, colorValue, theme);

    return (
        <Typography variant="body2" color={textColor || 'text.primary'}>
            {display}
        </Typography>
    );
};

GlanceCell.propTypes = {
    value: PropTypes.any,
    format: PropTypes.string,
    color: PropTypes.string,
    colorValue: PropTypes.number
};

export default GlanceCell;
